module.exports = __webpack_public_path__ + "static/assets/9bfcb820fba29b2ba2ca27854fbcf406.png";